import { render, staticRenderFns } from "./discount-assessor.vue?vue&type=template&id=b69f729c&"
import script from "./discount-assessor.vue?vue&type=script&lang=js&"
export * from "./discount-assessor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports